import React, { useState, useEffect } from "react";
import { Card, Box, Typography } from '@curves/ui-base';
import { MeasurementDateChip, MeasurementTitle } from "./Components/Common";
import { CIDBalanceSection, BodyAnalysisSection, BodyCompositionDistributionSection, ResearchParametersSection } from "./Components/DashboardPage";
import { isEmpty } from "@Util/utils";
import useMemberInbodyApi from "@Apis/useMemberInbodyApi";
import { useMeasurementContext } from "@Local/Measurement/Context/MeasurementContext";
import useShowLoading from "@Util/hook/useShowLoading";


const MeasurementDashboardPage = () => {
	const { dialogRef } = useMeasurementContext();
	const { getMemberInbodyDashboardApi, getMemberInbodyDashboardTrendApi } = useMemberInbodyApi();
	const [sourceData, setSourceData] = useState(null);
	const showLoading = useShowLoading();
	const [isLoaded, setIsLoaded] = useState(false);

	const doMemberInbodyDashboardApi = async () => {
		setIsLoaded(false);
		showLoading(true);
		try {
			const resp = await getMemberInbodyDashboardApi();
			if (resp) setSourceData(resp);
			else setSourceData(null);
		} finally {
			showLoading(false);
			setIsLoaded(true);
		}
	};

	const handleTrendLineChartDialog = async trendType => {
		if (trendType == null) return;
		const sourceData = await getMemberInbodyDashboardTrendApi(trendType);
		if (sourceData) {
			dialogRef.current.openTrendLineChartDialog(sourceData, trendType, () => getMemberInbodyDashboardTrendApi(trendType));
		}
	};

	const handleTrendAreaChartDialog = async trendType => {
		if (trendType == null) return;
		const sourceData = await getMemberInbodyDashboardTrendApi(trendType);
		if (sourceData) {
			dialogRef.current.openTrendAreaChartDialog(sourceData, trendType, () => getMemberInbodyDashboardTrendApi(trendType));
		}
	};

	useEffect(
		() => {
			doMemberInbodyDashboardApi();
		},
		// eslint-disable-next-line
		[],
	);

	return (
		<>
			{isLoaded && !isEmpty(sourceData) && (
				<Box className={"container py-4"}>
					<MeasurementDateChip measureDate={sourceData?.measureDate} />
					<Box className="measurement">
						<Box className="measurement-group">
							<MeasurementTitle title="C/I/D 平衡分析" />
							<CIDBalanceSection sourceData={sourceData} onTrendLineClick={handleTrendLineChartDialog} />
						</Box>
						<Box className="measurement-group">
							<MeasurementTitle title="體態分析" />
							<BodyAnalysisSection sourceData={sourceData} onTrendLineClick={handleTrendLineChartDialog} />
						</Box>
						<Box className="measurement-group">
							<MeasurementTitle title="身體組成分布" />
							<BodyCompositionDistributionSection sourceData={sourceData} onTrendAreaClick={handleTrendAreaChartDialog} />
						</Box>
						<Box className="measurement-group">
							<MeasurementTitle title="疾病風險評估" />
							<ResearchParametersSection sourceData={sourceData} onTrendLineClick={handleTrendLineChartDialog} />
						</Box>
					</Box>
				</Box>
			)}
			{isLoaded && isEmpty(sourceData) && (
				<Card className="page-center m-4">
					<Typography variant={"h6"} color={"error"}>
						無任何量身紀錄
					</Typography>
				</Card>
			)}
		</>
	);
};

export default MeasurementDashboardPage;
